import { render, staticRenderFns } from "./JgpMask.vue?vue&type=template&id=05965960&"
import script from "./JgpMask.vue?vue&type=script&lang=js&"
export * from "./JgpMask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports